var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25485_204688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 30.5146C24.6274 30.5146 30 25.1421 30 18.5146C30 11.8872 24.6274 6.51465 18 6.51465C11.3726 6.51465 6 11.8872 6 18.5146C6 25.1421 11.3726 30.5146 18 30.5146ZM18 33.5146C26.2843 33.5146 33 26.7989 33 18.5146C33 10.2304 26.2843 3.51465 18 3.51465C9.71573 3.51465 3 10.2304 3 18.5146C3 26.7989 9.71573 33.5146 18 33.5146Z",
    fill: "#ffbb00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 30.5147C24.6274 30.5147 30 25.1421 30 18.5147C30 11.8872 24.6274 6.51465 18 6.51465C11.3726 6.51465 6 11.8872 6 18.5147C6 25.1421 11.3726 30.5147 18 30.5147ZM18 33.5147C26.2843 33.5147 33 26.7989 33 18.5147C33 10.2304 26.2843 3.51465 18 3.51465C9.71573 3.51465 3 10.2304 3 18.5147C3 26.7989 9.71573 33.5147 18 33.5147Z",
    fill: "#ffbb00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13.6603C17.2039 12.9478 16.1525 12.5146 15 12.5146C12.5147 12.5146 10.5 14.529 10.5 17.0138C10.5 22.526 15.5036 25.1168 17.337 25.8811C17.7641 26.0592 18.2359 26.0592 18.663 25.8811C20.4964 25.1168 25.5 22.5261 25.5 17.0138C25.5 14.529 23.4853 12.5146 21 12.5146C19.8475 12.5146 18.7961 12.9478 18 13.6603Z",
    fill: "#ffbb00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25485_204688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.514648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurer);
export default __webpack_public_path__ + "static/media/Insurer.678950f5830e7401f97ec2f9c45d2cbd.svg";
export { ForwardRef as ReactComponent };